/**
 * @generated SignedSource<<f18f627cbfa5949e2ecac9ec5088fbce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SmartCreateFeedbackBanner_content$data = {
  readonly contentProperties: {
    readonly draft: {
      readonly generatedBy: string | null;
    } | null;
    readonly latest: {
      readonly generatedBy: string | null;
    } | null;
  } | null;
  readonly creatorId: string | null;
  readonly history: {
    readonly createdDate: string | null;
  } | null;
  readonly id: string | null;
  readonly title: string | null;
  readonly type: string | null;
  readonly version: {
    readonly number: number | null;
  } | null;
  readonly " $fragmentType": "SmartCreateFeedbackBanner_content";
};
export type SmartCreateFeedbackBanner_content$key = {
  readonly " $data"?: SmartCreateFeedbackBanner_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"SmartCreateFeedbackBanner_content">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "generatedBy"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SmartCreateFeedbackBanner_content",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "creatorId"
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "number"
        }
      ]
    },
    {
      "concreteType": "History",
      "kind": "LinkedField",
      "name": "history",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "createdDate"
        }
      ]
    },
    {
      "concreteType": "ContentProperties",
      "kind": "LinkedField",
      "name": "contentProperties",
      "plural": false,
      "selections": [
        {
          "concreteType": "DraftContentProperties",
          "kind": "LinkedField",
          "name": "draft",
          "plural": false,
          "selections": (v0/*: any*/)
        },
        {
          "concreteType": "PublishedContentProperties",
          "kind": "LinkedField",
          "name": "latest",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "595493a8435318cf19d6f444c7f0ddb5";

export default node;
